import { render, staticRenderFns } from "./CPopupFrame.vue?vue&type=template&id=69ebd8d2&"
import script from "./CPopupFrame.vue?vue&type=script&lang=ts&"
export * from "./CPopupFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports